<!-- Template -->

<template>
    <div v-if="visible" name="modal">
        <div
            class="modal modal-mask"
            style="display: block;"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                <div class="modal-content">
                    <!-- Header -->

                    <div class="modal-header">
                        <h4 class="modal-title">Request Support</h4>
                        <button
                            @click.prevent="close"
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true" class="icon-x"></span>
                        </button>
                    </div>

                    <!-- Body -->

                    <div class="modal-body">
                        <span v-if="loading" class="spinner-border modal-loader"></span>
                        <div v-if="systems.length > 0 && !loading" class="container">
                            <h1>For which system are you requesting support?</h1>
                            <form class="select-system">
                                <div v-for="system in systems" :key="system.id" class="form-group">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input
                                            type="radio"
                                            :id="'system_' + system.id"
                                            name="sys"
                                            class="custom-control-input"
                                            :value="system.id"
                                            v-on:change="setSelectedSystem(system.id)"
                                        />
                                        <label
                                            class="custom-control-label"
                                            :for="'system_' + system.id"
                                        >
                                            <h5>
                                                <span>{{system.dhrNumber}}</span>
                                                <span>{{system.productConfigurationDescription}}</span>
                                            </h5>
                                        </label>
                                    </div>
                                    <a v-if="system.hasOpenedTickets"
                                        href="#"
                                        @click.prevent="showOpenedTickets(system)"
                                        class="view-open-tickets"
                                    >View open tickets</a>
                                </div>
                                <div class="submit">
                                    <button
                                        type="button"
                                        class="btn-large btn-blue"
                                        :disabled="disabled"
                                        @click.prevent="onSelect()"
                                    >
                                        <span>Select</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<!-- Script -->

<script>
    import { SystemService } from "@/services/system-service";

    export default {
        name: "TicketSystem",

        data() {
            return {
                visible: false,
                systems: [],
                selectedSystem: null,
                disabled: true,
                loading: true
            };
        },

        watch: {
            $route() {
                this.update();
            }
        },

        created() {
            this.systemService = new SystemService(this.$api, this.$store);
            this.update();
        },

        methods: {
            show() {
                this.visible = true;
                this.loading = true;
            },
            close() {
                this.visible = false;
                
            },

            setSelectedSystem(id) {
                this.disabled = false;
                this.selectedSystem = id;
                for (var i = 0; i < this.systems.length; i++) {
                    if (this.systems[i].id == this.selectedSystem) {
                        this.system = this.systems[i];
                    }
                }
            },

            onSelect() {
                this.disabled = true;
                this.close();
                this.$emit("select", this.system);
            },

            async update() {
                var response = await this.systemService.list(
                    this.$route.params.hospital
                );

                var filteredResponse = response.filter(el => {
                    return el.trainingStatus.toLowerCase() == "complete";
                });

                if(filteredResponse.length > 0){
                    for(var i = 0; i < filteredResponse.length; i++){
                        var system = await this.systemService.getSystem(filteredResponse[i].id);
                        var tickets = system.supportTickets;
                        var openedTickets = tickets.filter(function(ticket) {
                            return ticket.statusId == 1;
                        });

                        if(openedTickets.length > 0){
                            filteredResponse[i].hasOpenedTickets = true;
                        }
                    }
                }

                this.systems = filteredResponse;   
                this.loading = false;            

            },

            showOpenedTickets(sys) {
                this.disabled = true;
                this.close();
                this.$emit("viewOpenedTickets", sys);
            }
        }
    };
</script>

